<template>
  <div
    id="mediacontent-list"
    v-infinite-scroll="getMoreItems"
    infinite-scroll-disabled="busy"
    infinite-scroll-distance="10"
    infinite-scroll-immediate-check="false"
    :class="outerPadding"
  >
    <list
      model-name="mediacontent"
      :items-url="URL"
      :params="params"
      :flex-class="'pa-3'"
      :list-break-point="mediaBreakpoint"
    >
      <template slot-scope="props">
        <h3>{{ props.item.name }}</h3>
        <div class="mt-1">
          {{ $t("variables.contentLanguage") }}: {{ props.item.content_language }}<br>
          {{ $t("variables.seriesKnitting") }}: {{ props.item.contents_quantity }}
        </div>
        <v-btn
          style="margin: 20px 0 0 0; width: 100%; text-transform: inherit;"
          @click.stop="linkTo(getDetailUrl(props.item))"
        >
          {{ $t("variables.viewDetail") }}
        </v-btn>
      </template>
    </list>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll'
import List from 'components/List.vue'

export default {
  directives: { infiniteScroll },
  components: {
    'list': List
  },
  data () {
    return {
      URL: '/api/products/mediacontent/',
      items: [],
      nextLink: ''
    }
  },
  computed: {
    mediaBreakpoint () {
      return {
        'xs': 12,
        'sm': 6,
        'md': 6,
        'lg': 6,
        'xl': 6
      }
    },
    outerPadding () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
        case 'md': return 'px-4'
        default: return ''
      }
    },
    params () {
      return { category: this.$route.params.category }
    }
  },
  watch: {
    '$route.params' () {
      this.getInitialItems()
    },
    '$vuetify.breakpoint.name' (bp) {
    }
  },
  beforeMount () {
    this.getInitialItems()
  },
  methods: {
    getInitialItems () {
      this.params.lang = this.$language.locale
      this.$http.get(this.URL, { params: this.params })
        .then(response => {
          this.items = response.data.results
          this.nextLink = response.data.next
        })
    },
    getMoreItems () {
      if (this.nextLink === null || this.nextLink === undefined) {
        return
      }
      this.busy = true
      this.$http.get(this.nextLink)
        .then(response => {
          this.items = this.items.concat(response.data.results)
          this.nextLink = response.data.next
          this.busy = false
        })
    },
    getDetailUrl (item) {
      let category = this.$route.params.category ? this.$route.params.category : 'all'
      return '/' + this.$language.locale + '/mediacontent/' + category + '/' + item.code
    },
    linkTo (address) {
      this.$router.push(address)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/contents/MediaContentList.vue